import '.e0{z-index:3;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.e1{width:300px;}.ssr-plugin'
import '.e2{padding:8px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.do{gap:2px;}.ssr-plugin'
import '.de{outline:none;}.ssr-plugin'
import React, { useState, useMemo } from 'react'
import { Dropdown } from '../Dropdown/index.js'
import { colors } from '../../tokens/colors.js'
import { shadows } from '../../utils/shadows.js'
import { radius } from '../../utils/radius.js'
import { ColorPicker } from './ColorPicker.js'
import type { COLOR_FORMAT } from './utils.js'
import { Media } from '../Media/index.js'
import { Overlay } from '../Overlay/index.js'
import { styled, Style } from 'inlines'
import { LabelDescription } from '../LabelDescription/index.js'

export type ColorModalProps = {
  children: React.ReactNode
  colorFormat?: COLOR_FORMAT
  value?: string
  onChange: (value: string) => void
  placement?: 'bottom-start' | 'bottom-end'
  setColorFormat?: (colorFormat: COLOR_FORMAT) => void
  setOpen: (open: boolean) => void
}

const ColorModal = ({
  children,
  colorFormat,
  setColorFormat,
  value: cValue,
  onChange,
  setOpen,
}: ColorModalProps) => {
  const value = useMemo(
    // !TODO -> convert to color format if
    () => (cValue ? cValue : undefined),
    [cValue],
  )

  return (
    <Overlay
      scrollableParent
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      position="bottom"
    >
      <Overlay.Trigger>{children}</Overlay.Trigger>
      <Overlay.Content>
        <div className="e0 a0 e1 e2 a i do de"
          style={{
            borderRadius: radius[20],
            background: `linear-gradient(${colors.neutral10Background}),
              linear-gradient(${colors.neutralInverted100})`,
            boxShadow: shadows.popoverLarge,
          }}
        >
          <ColorPicker
            colorFormat={colorFormat}
            setColorFormat={setColorFormat}
            value={value}
            onChange={(value) => {
              onChange(value)
            }}
            // placement={placement}
          />
        </div>
      </Overlay.Content>
    </Overlay>
  )
}

type ColorInputProps = {
  value?: string
  onChange: (value: string) => void
  format?: 'RGB' | 'HEX' | 'HSL'
  error?: boolean
  disabled?: boolean
  placeholder?: string
  style?: Style
  label?: string
  description?: string
  errorMessage?: string
}

export const ColorInput = ({
  value,
  label,
  description,
  errorMessage = 'Invalid color',
  onChange,
  format = 'RGB',
  error,
  disabled,
  placeholder,
  style,
}: ColorInputProps) => {
  const [colorFormat, setColorFormat] = useState(format)
  const [open, setOpen] = useState(false)

  return (
    <LabelDescription
      label={label}
      description={description}
      error={error && errorMessage}
      style={{ width: '100%' }}
    >
      <ColorModal
        colorFormat={colorFormat}
        setColorFormat={setColorFormat}
        value={value}
        onChange={onChange}
        setOpen={setOpen}
      >
        <Dropdown
          open={open}
          error={error}
          prefix={
            <Media
              size="small"
              src={value}
              type="color"
              style={{ marginRight: 8 }}
            />
          }
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          style={{ width: '100%', minWidth: 280, ...style }}
        />
      </ColorModal>
    </LabelDescription>
  )
}
